import { client } from "./axios";
import { CREATE_FEATURE_COMMENTS } from "./endpoints";

export type CommentAttachmentInput = {
  file_name: string;
};

export type CommentInput = {
  description: string;
  attachments?: CommentAttachmentInput[];
};

export type CommentAttachmentResponse = {
  attachment_id: string;
  file_name: string;
  upload_url: string;
  expires_in: number;
};

export type CommentResponse = {
  comment_id: string;
  description: string;
  attachments: CommentAttachmentResponse[];
};

export type CreateBulkCommentsResponse = {
  comments: CommentResponse[];
};

export const createBulkComments = async (
  featureInstanceId: string,
  comments: CommentInput[],
  projectToken: string
) => {
  try {
    const response = await client.post<CreateBulkCommentsResponse>(
      CREATE_FEATURE_COMMENTS(featureInstanceId),
      { comments },
      {
        headers: {
          Authorization: `Bearer ${projectToken}`
        }
      }
    );
    return response;
  } catch (ex) {
    return { error: ex };
  }
};
